import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck, Smartphone, Building2, ArrowRight } from 'lucide-react';

const portals = [
  { icon: ShieldCheck, title: 'Admin Login', desc: 'CRM & Website Admin Panel', to: '/admin/login', color: 'from-[#0A2463] to-[#247BA0]', testId: 'portal-admin-login' },
  { icon: Smartphone, title: 'Mobile CRM Login', desc: 'Sales Team Mobile App', to: '/m/login', color: 'from-emerald-600 to-teal-500', testId: 'portal-mobile-login' },
  { icon: Building2, title: 'ERP Login', desc: 'Accounting & Bookkeeping Software', to: '/erp/login', color: 'from-orange-500 to-amber-500', testId: 'portal-erp-login' },
];

export const LoginPortals = () => (
  <section className="py-14 bg-gradient-to-b from-gray-50 to-white" data-testid="login-portals-section">
    <div className="container mx-auto px-4">
      <div className="text-center mb-8">
        <h2 className="text-2xl md:text-3xl font-bold text-[#0A2463]">Quick Access Portals</h2>
        <p className="text-gray-500 mt-1 text-sm">Team members ke liye direct login</p>
      </div>
      <div className="grid md:grid-cols-3 gap-6 max-w-4xl mx-auto">
        {portals.map((p) => {
          const Icon = p.icon;
          return (
            <Link key={p.title} to={p.to} data-testid={p.testId} className="group relative bg-white rounded-2xl border border-gray-100 shadow-lg hover:shadow-2xl hover:-translate-y-1.5 transition-all duration-300 p-6 overflow-hidden">
              <div className={`absolute inset-x-0 top-0 h-1.5 bg-gradient-to-r ${p.color}`} />
              <div className={`w-14 h-14 rounded-2xl bg-gradient-to-br ${p.color} text-white flex items-center justify-center mb-4 group-hover:scale-110 transition-transform shadow-lg`}>
                <Icon size={26} />
              </div>
              <h3 className="text-lg font-bold text-gray-800">{p.title}</h3>
              <p className="text-sm text-gray-500 mt-1">{p.desc}</p>
              <span className="inline-flex items-center gap-1 text-sm font-semibold text-[#247BA0] mt-3 group-hover:gap-2.5 transition-all">
                Login karein <ArrowRight size={15} />
              </span>
            </Link>
          );
        })}
      </div>
    </div>
  </section>
);

export default LoginPortals;
